import { render } from "./ProjectNotes.vue?vue&type=template&id=73ab08c3&scoped=true"
import script from "./ProjectNotes.vue?vue&type=script&lang=js"
export * from "./ProjectNotes.vue?vue&type=script&lang=js"

import "./ProjectNotes.vue?vue&type=style&index=0&id=73ab08c3&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ab08c3"]])

export default __exports__